import { _ } from "../../polyglot/polyglot.js";
import { Widget } from "@foretagsplatsen/widgetjs";

/**
 * Render the header of a WizardWidget.
 *
 * @param {Wizard} wizard - wizard upon which to act
 * @param {Renderer} [titleRenderer] - The function is passed the current
 *   and last step 1-based indices as parameters and is expected to
 *   return a title for the header
 */
export default class WizardHeaderWidget extends Widget {
	constructor({
		wizard,
		titleRenderer = ({ currentIndex, lastIndex }) =>
			_("Step {currentIndex} of {lastIndex}", {
				currentIndex,
				lastIndex,
			}),
	}) {
		super(...arguments);

		this._wizard = wizard;
		this._titleRenderer = titleRenderer;
	}

	renderContentOn(html) {
		html.h3(this._buildTitle());
	}

	_buildTitle() {
		const currentIndex = this._wizard.getCurrentStepIndex();
		const lastIndex = this._wizard.getLastStepIndex();
		return this._titleRenderer({
			currentIndex: currentIndex + 1,
			lastIndex: lastIndex + 1,
		});
	}
}
